import { MULTI_SESSION_ENABLED_PROPERTY } from './wireContract';

/** The one reading of the client flag, so every part of the feature switches together. */
export const isMultiSessionEnabled = (): boolean =>
  Boolean(window.spa_variables?.properties?.[MULTI_SESSION_ENABLED_PROPERTY]);
